<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Edição de informações pendentes do pedido</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        <h4> Endereço de cobrança </h4>
          <div class="l-row">
            <form-group :columns="2" class="ds-block form-flex" :label="$t('zipCode.label')" :required="true" :error="getError('customerAddress.zipCode')">
              <input v-model="customerAddress.zipCode" class="form-input" >
            </form-group>
          </div>
          <div class="l-row">
            <form-group :columns="5" class="ds-block form-flex" :label="$t('street.label')" :required="true" :error="getError('customerAddress.street')">
              <input v-model="customerAddress.street" class="form-input">
            </form-group>
            <form-group :columns="2" class="ds-block form-flex" :label="$t('number.label')" :required="true" :error="getError('customerAddress.number')">
              <input v-model="customerAddress.number" class="form-input">
            </form-group>
            <form-group :columns="5" class="ds-block form-flex" :label="$t('complement.label')">
              <input v-model="customerAddress.complement" class="form-input">
            </form-group>
          </div>

          <div class="l-row">
            <form-group :columns="5" class="ds-block form-flex" :label="$t('district.label')" :required="true" :error="getError('customerAddress.district')">
              <input v-model="customerAddress.district" class="form-input">
            </form-group>
            <form-group :columns="5" class="ds-block form-flex" :label="$t('city.label')" :required="true" :error="getError('customerAddress.city')">
              <input v-model="customerAddress.city" class="form-input">
            </form-group>
            <form-group :columns="2" class="ds-block form-flex" :label="$t('state.label')" :required="true" :error="getError('customerAddress.state')">
              <select v-model="customerAddress.state" class="form-select">
                <option v-for="state in states" :value="state" :key="state">{{ state }}</option>
              </select>
            </form-group>
          </div>

          <div class="l-row">
            <form-group :columns="6" class="ds-block l-col form-flex" :label="$t('name.label')" :required="true" :error="getError('customerAddress.name')">
              <input v-model="customerAddress.name" class="form-input">
            </form-group>
            <form-group :columns="6" class="ds-block l-col form-flex" :label="$t('referenceAddress.label')">
              <input v-model="customerAddress.reference" class="form-input">
            </form-group>
          </div>

        <h4> Endereço de entrega </h4>
        <div class="l-row">
          <form-group :columns="2" class="ds-block form-flex" :label="$t('zipCode.label')" :required="true" :error="getError('shippingAddress.zipCode')">
            <input v-model="shippingAddress.zipCode" class="form-input">
          </form-group>
        </div>
        <div class="l-row">
          <form-group :columns="5" class="ds-block form-flex" :label="$t('street.label')" :required="true" :error="getError('shippingAddress.street')">
            <input v-model="shippingAddress.street" class="form-input">
          </form-group>
          <form-group :columns="2" class="ds-block form-flex" :label="$t('number.label')" :required="true" :error="getError('shippingAddress.number')">
            <input v-model="shippingAddress.number" class="form-input">
          </form-group>
          <form-group :columns="5" class="ds-block form-flex" :label="$t('complement.label')">
            <input v-model="shippingAddress.complement" class="form-input">
          </form-group>
        </div>

        <div class="l-row">
          <form-group :columns="5" class="ds-block form-flex" :label="$t('district.label')" :required="true" :error="getError('shippingAddress.district')">
            <input v-model="shippingAddress.district" class="form-input">
          </form-group>
          <form-group :columns="5" class="ds-block form-flex" :label="$t('city.label')" :required="true" :error="getError('shippingAddress.city')">
            <input v-model="shippingAddress.city" class="form-input">
          </form-group>
          <form-group :columns="2" class="ds-block form-flex" :label="$t('state.label')" :required="true" :error="getError('shippingAddress.state')">
            <select v-model="shippingAddress.state" class="form-select">
              <option v-for="state in states" :value="state" :key="state">{{ state }}</option>
            </select>
          </form-group>
        </div>

        <div class="l-row">
          <form-group :columns="6" class="ds-block l-col form-flex" :label="$t('name.label')" :required="true" :error="getError('shippingAddress.name')">
            <input v-model="shippingAddress.name" class="form-input">
          </form-group>
          <form-group :columns="6" class="ds-block l-col form-flex" :label="$t('referenceAddress.label')">
            <input v-model="shippingAddress.reference" class="form-input">
          </form-group>
        </div>

        <h4>Valor do frete</h4>
        <form-group label="Frete" :columns="3" :required="true" :error="getError('shipping')">
          <money v-model="shipping" v-bind="money" class="form-input"/>
        </form-group>
      </div>
      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não editar</button>
        <button type="button" class="btn btn--success" @click="confirm()">Atualizar informações</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import { mapGetters } from 'vuex'
  import api from '@/api'
  import FormGroup from '@/components/template/FormGroup'
  import Select from '../../table/Select'
  import { Money } from 'v-money'
  import notifier from '@/notifier'

  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      customerAddress: {
        name: '',
        street: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
        zipCode: '',
        reference: ''
      },
      shippingAddress: {
        name: '',
        street: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
        zipCode: '',
        reference: ''
      },
      shipping: 0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      states: [
        'AC',
        'AL',
        'AP',
        'AM',
        'BA',
        'CE',
        'DF',
        'ES',
        'GO',
        'MA',
        'MT',
        'MS',
        'MG',
        'PA',
        'PB',
        'PR',
        'PE',
        'PI',
        'RJ',
        'RN',
        'RS',
        'RO',
        'RR',
        'SC',
        'SP',
        'SE',
        'TO']
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      errors: {
        type: Array,
        required: false
      },
      order: {
        type: Object,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        if (!this.customerAddress.name) {
          notifier.error('Por gentileza preencha o campo nome do endereço de cobrança.', 'Erro')
          return false
        }
        if (!this.customerAddress.street) {
          notifier.error('Por gentileza preencha o campo nome da rua no endereço de cobrança.', 'Erro')
          return false
        }
        if (!this.customerAddress.number) {
          notifier.error('Por gentileza preencha o campo número do endereço de cobrança.', 'Erro')
          return false
        }
        if (!this.customerAddress.district) {
          notifier.error('Por gentileza preencha o campo bairro do endereço de cobrança.', 'Erro')
          return false
        }
        if (!this.customerAddress.city) {
          notifier.error('Por gentileza preencha o campo cidade do endereço de cobrança.', 'Erro')
          return false
        }
        if (!this.customerAddress.state) {
          notifier.error('Por gentileza marque o estado do endereço de cobrança.', 'Erro')
          return false
        }
        if (!this.customerAddress.zipCode) {
          notifier.error('Por gentileza preencha o campo cep do endereço de cobrança.', 'Erro')
          return false
        }

        if (!this.shippingAddress.name) {
          notifier.error('Por gentileza preencha o campo nome do endereço de entrega.', 'Erro')
          return false
        }
        if (!this.shippingAddress.street) {
          notifier.error('Por gentileza preencha o campo nome da rua no endereço de entrega.', 'Erro')
          return false
        }
        if (!this.shippingAddress.number) {
          notifier.error('Por gentileza preencha o campo número do endereço de entrega.', 'Erro')
          return false
        }
        if (!this.shippingAddress.district) {
          notifier.error('Por gentileza preencha o campo bairro do endereço de entrega.', 'Erro')
          return false
        }
        if (!this.shippingAddress.city) {
          notifier.error('Por gentileza preencha o campo cidade do endereço de entrega.', 'Erro')
          return false
        }
        if (!this.shippingAddress.state) {
          notifier.error('Por gentileza marque o estado do endereço de entrega.', 'Erro')
          return false
        }
        if (!this.shippingAddress.zipCode) {
          notifier.error('Por gentileza preencha o campo cep do endereço de entrega.', 'Erro')
          return false
        }

        if (!this.shipping) {
          notifier.error('Por gentileza adcionar o valor do frete.', 'Erro')
          return false
        }
        this.order.customer.address = this.customerAddress
        this.order.shipping.address = this.shippingAddress
        this.order.payment.shipping = this.shipping

        this.$emit('confirm', true)
        this.close()
      },
      cancel () {
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    components: {
      api,
      Money,
      Select,
      FormGroup,
      notifier
    }
  }
</script>

<style lang="sass" scoped>
  .c-modalCard
    width: 900px
    align-content: center

  .c-modal--sm
    .c-modal__content
      max-width: 900px


</style>



// WEBPACK FOOTER //
// ModalEditPendingInformation.vue?0f0454e0